import { render, staticRenderFns } from "./ClinicalSkillsGroupInformation.vue?vue&type=template&id=319adca3&scoped=true&"
import script from "./ClinicalSkillsGroupInformation.vue?vue&type=script&lang=js&"
export * from "./ClinicalSkillsGroupInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319adca3",
  null
  
)

export default component.exports